"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMeristemContext = void 0;
var meristemContext_1 = require("./utils/meristemContext");
Object.defineProperty(exports, "getMeristemContext", { enumerable: true, get: function () { return __importDefault(meristemContext_1).default; } });
__exportStar(require("./types/declarations"), exports);
__exportStar(require("./utils/contants/constants"), exports);
__exportStar(require("./utils/route/routeMappings"), exports);
//# sourceMappingURL=index.js.map